// ============================================================================
// EU Tire API Response Types (based on GetTireBoundResponse and GetTireRecommendedResponse)
// ============================================================================

export enum TirePressureUnit {
  PSI = 0,
  KPA = 1,
  BAR = 2,
}

export type TireBoundStatus = 'lower' | 'higher' | 'inbound';

/**
 * EU Tire Bound API 응답 타입
 * Based on GetTireBoundResponse
 */
export interface TireBoundResponse {
  agreeDt: string;
  specType: string;
  cars: string;
  mdy: string;
  ignOnTime: string;
  ignOffTime: string;
  tripLength: number;
  drvDistance: number;
  normalTime: number;
  firstFl: number;
  firstFr: number;
  firstRl: number;
  firstRr: number;
  firstUnit: TirePressureUnit;
  cstaAvg: number;
  tireTime: string;
  scoreTime: string;
  flBound: TireBoundStatus;
  frBound: TireBoundStatus;
  rlBound: TireBoundStatus;
  rrBound: TireBoundStatus;
  tirePressureLampFL: number;
  tirePressureLampFR: number;
  tirePressureLampRL: number;
  tirePressureLampRR: number;
  unsupported: boolean;
}

/**
 * EU Tire Recommended Data Item
 * Based on GetTireRecommendedData
 */
export interface TireRecommendedItem {
  frontTire: string;
  rearTire: string;
  frontPsi: number;
  rearPsi: number;
  lowerBoundFrontPsi: number;
  upperBoundFrontPsi: number;
  lowerBoundRearPsi: number;
  upperBoundRearPsi: number;
}

/**
 * EU Tire Info (타이어 목록용)
 */
export interface TireInfo {
  frontTire: string;
  rearTire: string;
}

/**
 * EU Tire Recommended API 응답 타입
 * Based on GetTireRecommendedResponse
 * EU 스펙: registeredTire 대신 registeredFrontTire, registeredRearTire 사용
 */
export interface TireRecommendedResponse {
  tirePsiList: TireRecommendedItem[];
  tires: TireInfo[];
  registeredFrontTire?: string;
  registeredRearTire?: string;
}

// ============================================================================
// UI Types
// ============================================================================

export interface TireData {
  pressure: number;
  isCaution: boolean;
}

export interface TirePosition {
  frontLeft: TireData;
  frontRight: TireData;
  rearLeft: TireData;
  rearRight: TireData;
}

export interface PressureItem {
  pressure: number;
  unit: string;
}

export interface RecommendedTireData {
  tireName: string;
  frontPressure: PressureItem;
  rearPressure: PressureItem;
}

export type TirePositionType = 'front left' | 'front right' | 'rear left' | 'rear right';

/**
 * 타이어 선택 결과 (EU 버전)
 * 바텀시트에서 반환되는 타입
 */
export interface SelectedTireEU {
  frontTire: string;
  rearTire: string;
}
